import { render, staticRenderFns } from "./AttributeTableIndicators.vue?vue&type=template&id=c9d977fc"
import script from "./AttributeTableIndicators.vue?vue&type=script&lang=js"
export * from "./AttributeTableIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports